window.initSwipers = function(context = document) {
  context.querySelectorAll('.swiper').forEach(function (sliderEl) {
    if (

      sliderEl.id === 'product-gallery-thumbnails' ||
      sliderEl.id === 'product-gallery-swiper'
    ) {
      return;
    }
    let config = {};
    try {
      config = JSON.parse(sliderEl.dataset.swiper || '{}');
    } catch (e) {
      console.error("Invalid JSON in data-swiper", e);
    }

    const defaultConfig = {
      enabled: true,
      loop: false,
      autoplay: false,
      slidesPerView: 1.5,
      spaceBetween: 24,
      centerInsufficientSlides: true,
      breakpoints: {
        640: {
          slidesPerView: 2.5,
          spaceBetween: 32
        },
        768: {
          slidesPerView: 4
        }
      },
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'fraction',
      },
      navigation: {
        nextEl: sliderEl.querySelector('.swiper-button-next'),
        prevEl: sliderEl.querySelector('.swiper-button-prev'),
      },
    };

    if (config.breakpoints) {
      defaultConfig.breakpoints = {
        ...defaultConfig.breakpoints,
        ...config.breakpoints
      };
      delete config.breakpoints;
    }

    const finalConfig = { ...defaultConfig, ...config };

    const swiper = new Swiper(sliderEl, finalConfig);
    
    const playButton = sliderEl.querySelector('.swiper-button-play');
    const pauseButton = sliderEl.querySelector('.swiper-button-pause');

    if (playButton && pauseButton) {
      playButton.addEventListener('click', () => {
        swiper.autoplay.start();
      });

      pauseButton.addEventListener('click', () => {
        swiper.autoplay.stop();
      });

      swiper.on('autoplayStart', () => {
        playButton.style.display = 'none';
        pauseButton.style.display = 'inline-block';
        pauseButton.focus();
      });
      swiper.on('autoplayStop', () => {
        playButton.style.display = 'inline-block';
        pauseButton.style.display = 'none';
        playButton.focus();
      });

      if (swiper.autoplay.running) {
        playButton.style.display = 'none';
        pauseButton.style.display = 'inline-block';
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  window.initSwipers();
});
